import React from "react";
import { Box, Paper } from '@material-ui/core';
import Chip from '@material-ui/core/Chip';

export default class ComponentToPrint extends React.Component {

  render() {
    const searchData = this.props.searchData;
    const customerData = this.props.customerData;
    const showTable = this.props.showTable;
    const groupDataByDay = this.props.groupDataByDay;
    const getColumnDays = this.props.getColumnDays;
    const selectedDate = this.props.selectedDate;
    const customerName = this.props.customerName;
    const totals = this.props.totals
    const data = this.props.data

    const tableCellStyle = {
      border: '1px solid #000',
      padding: '8px',
      textAlign: 'center',
      fontFamily: 'sans-serif',
      fontSize: '16px'
    };

    return (
      <Paper elevation={0} style={{ width: '100%', height: '100%' }}>
        <div>
          <h2><center>Leaf Supplier Card Details Report</center></h2>
          <div>&nbsp;</div>
          <h2 style={{ textAlign: 'center' }}>{searchData.groupName} - {searchData.factoryName}</h2>
          <div>&nbsp;</div>
          <h2 style={{ textAlign: 'center' }}>Route: {searchData.routeName || 'All Routes'}</h2>
          <div>&nbsp;</div>
          <h3 style={{ textAlign: 'center' }}> Month of {new Date(selectedDate).toLocaleString('en-US', { month: 'long' })} - {new Date(selectedDate).getFullYear()} </h3>
          <div>&nbsp;</div>
          <h2 style={{ textAlign: 'left' }}>Customer Name: {customerName || '-'}</h2>
          <div>&nbsp;</div>
          <h2 style={{ textAlign: 'left' }}>Registration Number: {data.registrationNumber || '-'}</h2>
          <br />
          <br />
          <div>
            <Box minWidth={1050}>
              {showTable && (
                <Box
                  display="grid"
                  gridTemplateColumns="repeat(4, 1fr)"
                  gridGap={10}
                  sx={{
                    height: '1000px',
                    overflow: 'auto'
                  }}
                >
                  {Array(4).fill().map((_, columnIndex) => {
                    const daysData = groupDataByDay();
                    const { startDay, endDay } = getColumnDays(columnIndex);

                    return (
                      <Box
                        key={columnIndex}
                        sx={{
                          height: '100%',
                          minHeight: '1000px',
                          display: 'flex',
                          flexDirection: 'column',
                          border: '1px solid #ccc',
                          overflow: 'auto'
                        }}
                      >
                        <table style={{
                          width: '100%',
                          flexGrow: 1
                        }}>
                          <thead>
                            <tr>
                              <th style={{ fontFamily: 'sans-serif', fontSize: '18px' }} className={tableCellStyle.tableCell}>Day</th>
                              <th style={{ fontFamily: 'sans-serif', fontSize: '18px' }} className={tableCellStyle.tableCell}>Super /Kg</th>
                              <th style={{ fontFamily: 'sans-serif', fontSize: '18px' }} className={tableCellStyle.tableCell}>Normal /Kg</th>
                              <th style={{ fontFamily: 'sans-serif', fontSize: '18px' }} className={tableCellStyle.tableCell}>Total /Kg</th>
                            </tr>
                          </thead>
                          <tbody>
                            {Array.from({ length: 8 }, (_, rowIndex) => {
                              const day = startDay + rowIndex;
                              const dayEntries = daysData[day] || [];
                              if (dayEntries.length === 0) {
                                return (
                                  <tr key={day}>
                                    <td className={tableCellStyle.tableCell}>{day}</td>
                                    <td style={{ border: '1px solid #000', padding: '2px', textAlign: 'center' }} className={`${tableCellStyle.tableCell} ${tableCellStyle.totalCell}`}>--</td>
                                    <td style={{ border: '1px solid #000', padding: '2px', textAlign: 'center' }} className={`${tableCellStyle.tableCell} ${tableCellStyle.totalCell}`}>--</td>
                                    <td style={{ border: '1px solid #000', padding: '2px', textAlign: 'center' }} className={`${tableCellStyle.tableCell} ${tableCellStyle.totalCell}`}>--</td>
                                  </tr>
                                );
                              }
                              return dayEntries.map((entry, entryIndex) => (
                                <tr key={`${day}-${entryIndex}`}>
                                  <td className={tableCellStyle.tableCell}>
                                    {entryIndex === 0 ? day : ''}
                                  </td>
                                  <td style={{ border: '1px solid #000', padding: '2px', textAlign: 'right' }} className={`${tableCellStyle.tableCell} ${tableCellStyle.totalCell}`}>
                                    <span style={{ fontSize: '18px' }}>
                                      {entry.superNetWeight.toLocaleString('en-US', {
                                        minimumFractionDigits: 2,
                                        maximumFractionDigits: 2
                                      })}
                                    </span>
                                  </td>
                                  <td style={{ border: '1px solid #000', padding: '2px', textAlign: 'right' }} className={`${tableCellStyle.tableCell} ${tableCellStyle.totalCell}`}>
                                    <span style={{ fontSize: '18px' }}>
                                      {entry.normalNetWeight.toLocaleString('en-US', {
                                        minimumFractionDigits: 2,
                                        maximumFractionDigits: 2
                                      })}
                                    </span>
                                  </td>
                                  <td style={{ border: '1px solid #000', padding: '2px', textAlign: 'right' }} className={`${tableCellStyle.tableCell} ${tableCellStyle.totalCell}`}>
                                    <span style={{ fontWeight: 'bold', fontSize: '18px' }}>
                                      {(entry.superNetWeight + entry.normalNetWeight).toLocaleString('en-US', {
                                        minimumFractionDigits: 2,
                                        maximumFractionDigits: 2
                                      })}
                                    </span>
                                  </td>
                                </tr>
                              ));
                            })}
                          </tbody>
                        </table>
                      </Box>
                    );
                  })}
                </Box>

              )}
              <br></br>
              <br></br>
              <div>
                {showTable && (
                  <Box
                    mt={2}
                    display="flex"
                    justifyContent="center"
                    alignItems="center"
                    gap={12}
                  >
                    <Chip
                      size="small"
                      label={`Super Leaf Total /Kg : ${totals.superTotal !== undefined ? totals.superTotal.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : '--'}`}
                      style={{ marginRight: '20px', backgroundColor: '#ADD8E6', color: 'black', fontSize: '18px' }}
                    />
                    <Chip
                      size="small"
                      label={`Normal Leaf Total /Kg : ${totals.normalTotal !== undefined ? totals.normalTotal.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : '--'}`}
                      style={{ marginRight: '20px', backgroundColor: '#ADD8E6', color: 'black', fontSize: '18px' }}
                    />
                    <Chip
                      size="small"
                      label={`Total Leaf /Kg : ${totals.totalWeight !== undefined ? totals.totalWeight.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : '--'}`}
                      style={{ backgroundColor: '#ADD8E6', color: 'black', fontSize: '18px' }}
                    />
                  </Box>
                )}
              </div>
            </Box>
          </div>
          <div>&nbsp;</div>
          <h4><center>*******End of List*******</center></h4>
        </div>
      </Paper>
    );
  }
}
